import { useState } from 'react';
import { SidebarSubtitle, SidebarTitle } from '../../styles/stylesStyled';
import { BankAccount, Box } from './SettingsStyled';

import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { AddBankAccount } from '../Earnings/Withdraw/AddBankAccount';
import { EditBankAccount } from '../Earnings/Withdraw/EditBankAccount';

import { useTranslation } from 'react-i18next';
import Spinner from '../../components/common/Spinner';
import { P3 } from '../../styles/FontStyles';
import {
  Button,
  Flexed,
  FloatingButton,
  PageTitle
} from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';

import { showWallet } from '../../helpers/helperFunctions';

import { useWindowWide } from '../../helpers/wideScreen';
import {
  Icon,
  IconFlipMeWallet,
  IconSettingsRecalculate,
  IconSettingsTrash,
  IconWithdrawWallet
} from '../../styles/Icons';

import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

import { UserWalletStatus } from '../../types/wallets-types';

export const PaymentsSettings = () => {
  const { t } = useTranslation('settings');

  const { userInfo } = useAppSelector((state) => state.auth);

  const wide = useWindowWide(800);

  return (
    <>
      <PageTitle> {t('payments.wallets')}</PageTitle>
      {/* <FlipMeBanner isEarnings isOpen={isOpen} setIsOpen={setIsOpen} /> */}

      <Box style={{ marginTop: 20 }}>
        <Flexed gap='12px' style={{ marginBottom: 12 }}>
          <BankAccount
            style={{
              width: wide ? '30%' : ''
            }}
            selected={true}>
            <Flexed center gap='10px'>
              <Icon color={color.colors.primary900}>
                <IconWithdrawWallet />
              </Icon>

              <P3 semiBold>Main wallet</P3>
            </Flexed>
          </BankAccount>
          <BankAccount
            style={{
              width: wide ? '60%' : ''
            }}>
            <P3 semiBold>
              <Desktop>{userInfo?.user?.walletAddress}</Desktop>
              <Mobile>{showWallet(userInfo?.user?.walletAddress, -6)}</Mobile>
            </P3>
          </BankAccount>
        </Flexed>
      </Box>
    </>
  );
};

// import { useState } from 'react';
// import { SidebarSubtitle, SidebarTitle } from '../../styles/stylesStyled';
// import { BankAccount, Box } from './SettingsStyled';

// import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
// import { AddBankAccount } from '../Earnings/Withdraw/AddBankAccount';
// import { EditBankAccount } from '../Earnings/Withdraw/EditBankAccount';

// import { useTranslation } from 'react-i18next';
// import Spinner from '../../components/common/Spinner';
// import { P3 } from '../../styles/FontStyles';
// import {
//   Button,
//   Flexed,
//   FloatingButton,
//   PageTitle
// } from '../../styles/GlobalComponents';
// import { color } from '../../styles/GlobalStyles';

// import { showWallet } from '../../helpers/helperFunctions';

// import { useWindowWide } from '../../helpers/wideScreen';
// import {
//   Icon,
//   IconFlipMeWallet,
//   IconSettingsRecalculate,
//   IconSettingsTrash,
//   IconWithdrawWallet
// } from '../../styles/Icons';

// import { Desktop, Mobile } from '../../App';
// import { useAppDispatch, useAppSelector } from '../../app/hooks';
// import {
//   deleteUserWallet,
//   reactivateUserWallet
// } from '../../slices/wallets-slice';
// import { UserWalletModel, UserWalletStatus } from '../../types/wallets-types';

// export const PaymentsSettings = () => {
//   const { t } = useTranslation('settings');
//   const [isOpen2, setIsOpen2] = useState(false);
//   const [isOpen3, setIsOpen3] = useState(false);
//   const [isOpen4, setIsOpen4] = useState(false);
//   const [bank, setBank] = useState<UserWalletModel | null>(null);

//   const [isOpen, setIsOpen] = useState<boolean>(false);

//   const dispatch = useAppDispatch();
//   const { loading } = useAppSelector((state) => state.withdraw);
//   const { wallets } = useAppSelector((state) => state.wallets);

//   const wide = useWindowWide(800);

//   if (loading) return <Spinner fullScreen />;

//   const deleteWallet = (account: any) => {
//     if (account.status === UserWalletStatus.ACTIVATED && !account.isFlipme) {
//       return (
//         <Icon
//           onClick={() => {
//             setIsOpen3(true);
//             setBank(account);
//           }}
//           color={color.colors.neutral700}
//           pointer>
//           <IconSettingsTrash />
//         </Icon>
//       );
//     }
//   };

//   const reactivateWallet = (account: any) => {
//     if (account.status === UserWalletStatus.DEACTIVATED && !account.isFlipme) {
//       return (
//         <Icon
//           onClick={() => {
//             dispatch(reactivateUserWallet({ id: account.id }));
//           }}
//           color={color.colors.neutral700}
//           pointer>
//           <IconSettingsRecalculate />
//         </Icon>
//       );
//     }
//   };

//   return (
//     <>
//       <PageTitle> {t('payments.wallets')}</PageTitle>
//       {/* <FlipMeBanner isEarnings isOpen={isOpen} setIsOpen={setIsOpen} /> */}

//       <Box style={{ marginTop: 20 }}>
//         {wallets?.map((account, index) => (
//           <Flexed gap='12px' style={{ marginBottom: 12 }} key={index}>
//             <BankAccount
//               style={{
//                 width: wide ? '30%' : '',
//                 cursor: account?.isFlipme ? 'default' : 'pointer'
//               }}
//               selected={account.status === UserWalletStatus.ACTIVATED}
//               onClick={() => {
//                 if (
//                   account.status === UserWalletStatus.ACTIVATED &&
//                   !account?.isFlipme
//                 ) {
//                   setBank(account);
//                   setIsOpen4(!isOpen4);
//                 }
//               }}>
//               <Flexed center gap='10px'>
//                 {account?.isFlipme ? (
//                   <Icon ml='7'>
//                     <IconFlipMeWallet />
//                   </Icon>
//                 ) : (
//                   <Icon
//                     color={
//                       account.status !== 1
//                         ? color.colors.neutral400
//                         : color.colors.primary900
//                     }>
//                     <IconWithdrawWallet />
//                   </Icon>
//                 )}

//                 <P3
//                   color={account.status !== 1 ? color.colors.neutral400 : ''}
//                   semiBold>
//                   {account.label}
//                 </P3>
//               </Flexed>
//             </BankAccount>
//             <BankAccount
//               style={{
//                 width: wide ? '60%' : '',
//                 cursor: account?.isFlipme ? 'default' : 'pointer'
//               }}
//               onClick={() => {
//                 if (account.status === 1 && !account?.isFlipme) {
//                   setBank(account);
//                   setIsOpen4(!isOpen4);
//                 }
//               }}>
//               <P3
//                 color={account.status !== 1 ? color.colors.neutral400 : ''}
//                 semiBold>
//                 <Desktop>{account?.address}</Desktop>
//                 <Mobile>{showWallet(account?.address, -6)}</Mobile>
//               </P3>
//             </BankAccount>

//             {deleteWallet(account)}
//             {reactivateWallet(account)}
//           </Flexed>
//         ))}
//       </Box>

//       <SidebarModal
//         isOpen={isOpen3}
//         setOpen={setIsOpen3}
//         title={t('payments.delete_wallet_address')}
//         sidebarWidth={'508px'}>
//         <SidebarTitle>{t('payments.are_you_sure')}</SidebarTitle>
//         <SidebarSubtitle>{t('payments.info_about_deletion')}</SidebarSubtitle>

//         <BankAccount style={{ width: '100%' }}>
//           <Flexed center>
//             <Icon color={color.colors.primary900}>
//               <IconWithdrawWallet />
//             </Icon>
//             <P3 semiBold>
//               <Desktop>{bank?.address}</Desktop>
//               <Mobile>{showWallet(bank?.address || '', -20)}</Mobile>
//             </P3>
//           </Flexed>
//         </BankAccount>

//         <Button
//           m='20px auto 12px auto'
//           onClick={() => {
//             if (bank) {
//               dispatch(deleteUserWallet({ id: bank?.id }));
//               setIsOpen3(false);
//             }
//           }}>
//           {t('payments.delete_address')}
//         </Button>
//         <Button negative m='0 auto' onClick={() => setIsOpen3(false)}>
//           {t('payments.cancel')}
//         </Button>
//       </SidebarModal>
//     </>
//   );
// };
